import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMenuCollapsed, setConfig } from "../../../state/globalStore";
import { RootState } from "../../../store";
import iconList from "../../constants/fontAwesomeIcons";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import { useGetAllConfigsQuery } from "../../../state/globalApi";
import { buildLookupRequest } from "../../../state/connect-api";
import getConfigs from "../../../GetConfigs";


const useSideNav = () => {
  const { menuCollapsed } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const loginType = localStorage.getItem("LOGINTYPE");
  const location = useLocation();
  const { data: configData } = useGetAllConfigsQuery(buildLookupRequest());
  const configurations = getConfigs([
    "ctTRCRLookup",
    "ctCVLookup",
    "ctTRCRSchedQuery",
    "ctCVLSchedQuery",
    "ctActiveWarrantsPage",
    "cvEfilePage",
    "ordinanceUrl"
  ]);
  useEffect(() => {
    dispatch(setConfig(configData?.Data));
  }, [configData]);

  useEffect(() => {
    iconList;
  }, []);

  const toggle = () => {
    dispatch(setMenuCollapsed());
  };

  const handleExitClick = () => {
    document.cookie = `isLoggedIn=0;expires=${new Date(new Date().setFullYear(1900))};path=/`;
    localStorage.clear();
  };

  const buildSideMenu = () => {
    const loginCookie = document.cookie;
    const isLoggedIn = loginCookie && Number(loginCookie.split("=")[1]) ? true : false;
    return (
      <>
        {isLoggedIn && (
          <>
            <Menu.Item title="Home" key="/home" icon={<FontAwesomeIcon icon={["fas", "home"]} />}>
              Home
              <NavLink to="/home" children={""} />
            </Menu.Item>
            <Menu.ItemGroup key="CaseLookup" title="Case Lookup">
              {configurations.ctTRCRLookup=="true" && (<Menu.Item title="Traffic/Criminal Lookup" key={location.pathname.includes("/lookup") ? location.pathname : "/lookup"} icon={<FontAwesomeIcon icon={["fas", "search"]} />}>
                Traffic/Criminal Lookup
                <NavLink to="/lookup" children={""} />
              </Menu.Item>)}
              {configurations.ctCVLookup == "true" && (<Menu.Item title="Civil Lookup" key={location.pathname.includes("/civil/") && !location.pathname.includes("/civil/new") ? location.pathname : "/civil"} icon={<FontAwesomeIcon icon={["fas", "user"]} />}>
                Civil Lookup
                <NavLink to="/civil" children={""} />
              </Menu.Item>)}
              {configurations.ctActiveWarrantsPage == "true" && (<Menu.Item title="Active Warrants" key={location.pathname.includes("/warrants") ? location.pathname : "/warrants"} icon={<FontAwesomeIcon icon={["fas", "exclamation"]} />}>
                Active Warrants
                <NavLink to="/warrants" children={""} />
              </Menu.Item>)}
            </Menu.ItemGroup>
            <Menu.ItemGroup key="CaseScheduleQuery" title="Case Schedule Query">
              {configurations.ctTRCRSchedQuery == "true" && (
                <Menu.Item title="Traffic/Criminal Query" key={location.pathname.includes("/tr-cr-query") ? location.pathname : "/tr-cr-query"} icon={<FontAwesomeIcon icon={["fas", "balance-scale"]} />}>
                  Traffic/Criminal Query
                  <NavLink to="/tr-cr-query" children={""} />
                </Menu.Item>)}
              {configurations.ctCVLSchedQuery == "true" && (<Menu.Item title="Civil Query" key={location.pathname.includes("/civil-query") ? location.pathname : "/civil-query"} icon={<FontAwesomeIcon icon={["fas", "user-plus"]} />}>
                Civil Query
                <NavLink to="/civil-query" children={""} />
              </Menu.Item>)}
            </Menu.ItemGroup>
          </>
        )}
        <Menu.ItemGroup key="CourtMenu" title="Court Menu">
          {(configurations.cvEfilePage == "true" && isLoggedIn) && (<Menu.Item title="New Civil Case" key={location.pathname.includes("/civil/new") ? location.pathname : "/civil/new"} icon={<FontAwesomeIcon icon={["fas", "plus-square"]} />}>
            New Civil Case
            <NavLink to="/civil/new" children={""} />
          </Menu.Item>)}
          <Menu.Item title="Contact" key={"/contact"} icon={<FontAwesomeIcon icon={["fas", "globe"]} />}>
            Contact
            <NavLink to="/contact" children={""} />
          </Menu.Item>
          <Menu.Item title="Exit" key={"/"} icon={<FontAwesomeIcon icon={["fas", "sign-out-alt"]} />}>
            Exit
            <NavLink onClick={handleExitClick} to="/" children={""} />
          </Menu.Item>
        </Menu.ItemGroup>
        {loginType && (
          <Menu.ItemGroup key="AccountMenu" title="Account Menu">
            <Menu.Item title="Profile" key={"/profile"} icon={<FontAwesomeIcon icon={["fas", "user"]} />}>
              Profile
              <NavLink to="/profile" children={""} />
            </Menu.Item>
          </Menu.ItemGroup>
        )}
        <br />
        {configurations.ordinances && (
          <Menu.Item title="Codified Ordinances" key={9} icon={<FontAwesomeIcon icon={["fas", "angle-double-right"]} />}>
            Codified Ordinances
            <a href={configurations.ordinanceUrl} target="_blank" rel="noopener noreferrer" />
          </Menu.Item>
        )}
      </>
    );
  };

  return { buildSideMenu, toggle, menuCollapsed };
};

export default useSideNav;
